import React from "react";
import { Redirect } from "react-router-dom";
import * as Icon from "react-feather";

import UserService from "../../../services/UserService";

import "./flows.css";
import EngagementService from "../../../services/EngagementService";
import WComponent from "../../common/WComponent";
import PageHeading from "../../common/page_heading/PageHeading";
import RestrictedAccess from "../../common/restricted_access/RestrictedAccess";
import UtilityService from "../../../services/UtilityService";

class Flows extends WComponent {
	constructor() {
		super();

		this.state = {
			loading: false,

			flows: [],
			showMore: null,
			isNotAllowedResource : false
		};
	}

	async componentDidMount() {
		await this.resetComponent();
	}

	componentDidUpdate() {}

	async resetComponent() {
		await this.fetchFlows();
	}

	fetchFlows = async () => {
		let flows = await EngagementService.fetchFlows({});

		await this.update({
			flows
		});

		if(UtilityService.isNotAllowedResource({response : flows}))
		{
			await this.update({
				isNotAllowedResource : true
			});	
			return;		
		}

	};

	onChange(e) {
		this.update({ [e.target.name]: e.target.value });
	}

	renderStates(flow) {
		return (
			<div className="flows__item__states">
				Flow States:
				{flow.flow_states.map(fs => {
					let style = { backgroundColor: fs.color };
					return (
						<div className="flow__item__states__item" style={style}>
							{fs.name}
						</div>
					);
				})}
			</div>
		);
	}

	onShowMore = async flowId => {
		let { showMore } = this.state;

		showMore = showMore === flowId ? null : flowId;

		await this.update({
			showMore
		});
	};

	render() {
		let { flows, showMore, isNotAllowedResource } = this.state;

		if (isNotAllowedResource)
		{					
			return <RestrictedAccess/>
		}

		let userData = UserService.getUserData();

		if (userData.groupId === 2) {
			return <Redirect to={"/dashboard"} />;
		}

		return (
			<div className="container">
				<PageHeading section={"Settings"} title={"Flows"} />

				<div className="flows">
					{flows.map(f => {
						return (
							<div key={f.id} className="flows__item" onClick={() => this.onShowMore(f.id)}>
								<div className="flows__item__details">
									<div className="flows__item__details__item">Name: {f.name}</div>
									<div className="flows__item__details__item">Code: {f.code}</div>
									<div className="flows__item__details__itemz">Default Fiscal Frequency: {f.frequency} months</div>
									<div className="flows__item__details__actions">
										<Icon.ChevronDown />
									</div>
								</div>

								{showMore === f.id && this.renderStates(f)}
							</div>
						);
					})}
				</div>
			</div>
		);
	}
}

export default Flows;
